import {IBlock, IDatabase} from '../../../models';
import {IItem} from '../../select';
import {BLOCK_TYPE} from '../constants';
import {Method} from './constants';

export const createDefaultContent = (sourceOption?: IItem, destinationOption?: IItem) => {
  return {
    method: Method.APPEND,
    destination: destinationOption?.value || '',
    source: sourceOption?.label || '', // used for reference on the BE
    source_uid: sourceOption?.value || '',
    schema: '',
  }
}

export const sourceOptions = (blocks: IBlock[] | null) => {
  if (!blocks) {
    return [];
  }

  const options: any[] = [];
  blocks.forEach((block: IBlock) => {
    const {type, name, content_json = {}, uid} = block;

    if (!name) {
      return; // continue
    }

    if (type === BLOCK_TYPE.SQL || type === BLOCK_TYPE.API_REQUEST) {
      options.push({
        label: name,
        value: uid,
      });
    } else if (type === BLOCK_TYPE.TABLEAU && content_json.action === 'view_csv') {
      options.push({
        label: name,
        value: uid,
      });
    }
  });

  return options;
};

export const destinationOptions = (databases: any[]) => {
  return databases
    ?.filter((database: IDatabase) => !database?.gsheet_is_public)
    .map((database: IDatabase) => (
      {
        label: database.database_name as string,
        value: database.uid as string,
        backend: database.backend as string,
      })
    );
}
